// const cookie = require('cookie');
// const base64 = require('base-64');
// const getWs02Token = require('@dbk-legacy/wso2token').getToken;
// const getIPaddress = require('@dbk-legacy/wso2token').getIPaddress;
// module.exports = function parseRequestMetaData(metaData) {
//   const parsed = JSON.parse(base64.decode(metaData));
//   return {
//     qs: { userId: parsed.userId, destinationCurrency: parsed.destinationCurrency },
//     assetName: { assetClassName: parsed.assetClassName },
//     info: { sessionId: parsed.sessionId },
//     portfolio: { pfRelId: parsed.relId || parsed.portfolioId, relId: parsed.relId, branchCode: parsed.branchCode, language: parsed.langCode},
//     headers: {
//       'Authorization-Token': parsed.authHeader,
//       Cookie: cookie.serialize('JSESSIONID', parsed.sessionId),
//       Authorization: getWs02Token(),
//       'X-CLIENT-IP': getIPaddress()
//     }
//   }
// }



const cookie = require('cookie');
const { decode } = require('base-64');
// const decrypt = require('./decrypt')
const getWs02Token = require('@dbk-legacy/wso2token').getToken;
const getIPaddress = require('@dbk-legacy/wso2token').getIPaddress;
const getHeaders = require('@dbk-legacy/wso2token').getHeaders;
const getTxToken = require('@dbk-legacy/wso2token').getTxToken;

module.exports = function parseRequestMetaData(metaData) {
  const parsed = JSON.parse(decode(metaData));
  let authHeader = getHeaders();
  let token = getTxToken();
  
  if (!authHeader) {
    authHeader = parsed.authHeader
  }

  return {
    qs: { 
      // userId: parsed.userId && decrypt(parsed.userId), 
      userId: parsed.userId, 
      destinationCurrency: parsed.destinationCurrency
    },
    assetName: { assetClassName: parsed.assetClassName },
    info: { 
      sessionId: parsed.sessionId
    },
    portfolio: { 
      // pfRelId: parsed.relId || (parsed.portfolioId && decrypt(parsed.portfolioId)), 
      pfRelId: parsed.relId || parsed.portfolioId,
      // relId: parsed.relId && decrypt(parsed.relId), 
      relId: parsed.relId, 
      branchCode: parsed.branchCode,
      language: parsed.langCode
    },
    headers: {
      'Authorization-Token': authHeader,
      'Transaction-Token': token,
      Cookie: cookie.serialize('JSESSIONID', parsed.sessionId),
      Authorization: getWs02Token(),
      'X-CLIENT-IP': getIPaddress(),
    },
    channel: parsed.channel,
    deviceCode: parsed.deviceCode,
    configBranchCode: parsed.configBranchCode,
    assetSortKey:parsed.assetSortKey,
    assetSortAscending:parsed.assetSortAscending
  };
};
